/* ============================================================
   PBK ルース商品詳細 — 同意ゲート / 画像拡大モーダル / Info・Spec タブ /
   Stone's Story・Column カルーセル / Same Color / Recently
   既存: ModalDialog(global.js) / product-form.js を利用。
   window.PBKProductLoose.init(root) で外部（quick-view）から再初期化可能。
   ============================================================ */
(function () {
  'use strict';

  function escapeHtml(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function formatMoney(cents) {
    if (cents == null) return '';
    return '¥' + Math.round(cents / 100).toLocaleString('ja-JP');
  }

  /* スペック行「0.86ct / 12.5×9.2mm」。寸法は確定スキーマの size_mm_h（縦）× size_mm_w（横）が正で、
     旧 dimensions / size_mm はフォールバック（CL #214: h/w のみの実データで mm が落ちていた）。 */
  function buildSpec(p) {
    if (!p) return '';
    var parts = [];
    var carat = p.carat;
    if (carat != null && carat !== '' && carat !== 0) parts.push(carat + 'ct');
    var h = p.size_mm_h, w = p.size_mm_w;
    var dims = '';
    if (h != null && h !== '' && w != null && w !== '') dims = h + '×' + w;
    else if (h != null && h !== '') dims = String(h);
    else if (w != null && w !== '') dims = String(w);
    else if (p.dimensions) dims = String(p.dimensions).trim();
    else if (p.size_mm != null && p.size_mm !== '' && p.size_mm !== 0) dims = String(p.size_mm);
    if (dims) {
      if (!/mm\s*$/i.test(dims)) dims += 'mm';
      parts.push(dims);
    }
    return parts.join(' / ');
  }

  /* ---------- 商品カード HTML（pbk-loose-card.liquid と同構造・.pbk-pcard） ---------- */
  function looseCardHtml(p) {
    var code = p.code ? ' <span class="pbk-pcard__code">[ ' + escapeHtml(p.code) + ' ]</span>' : '';
    var img = p.img
      ? '<img class="pbk-pcard__img pbk-pcard__img--primary" src="' + escapeHtml(p.img) + '" alt="' + escapeHtml(p.title) + '" loading="lazy" decoding="async">'
      : '<span class="pbk-pcard__ph" aria-hidden="true"></span>';
    /* 2枚目画像（ホバークロスフェード用・存在時のみ） */
    if (p.img && p.img2) {
      img += '<img class="pbk-pcard__img pbk-pcard__img--secondary" src="' + escapeHtml(p.img2) + '" alt="" loading="lazy" decoding="async">';
    }
    var spec = p.spec ? '<span class="pbk-pcard__spec pbk-en-sans">' + escapeHtml(p.spec) + '</span>' : '';
    var price = p.price_varies ? escapeHtml(p.price_min_str) + '〜' : escapeHtml(p.price_str);
    /* nameOnly: 商品名 + 商品番号のみ（Recently・Figma 準拠） */
    var body = '<span class="pbk-pcard__name">' + escapeHtml(p.title) + code + '</span>';
    if (!p.nameOnly) {
      body += spec + '<span class="pbk-pcard__price pbk-en-sans">' + price + '</span>';
    }
    return '<li class="pbk-pcard">' +
      '<a class="pbk-pcard__link" href="' + escapeHtml(p.url) + '" aria-label="' + escapeHtml(p.title) + '">' +
        '<span class="pbk-pcard__media">' + img + '</span>' +
        '<span class="pbk-pcard__body">' + body + '</span>' +
      '</a>' +
      '<button type="button" class="pbk-pcard__fav" aria-label="お気に入りに追加" aria-pressed="false" data-pbk-fav data-product-handle="' + escapeHtml(p.handle || '') + '" data-product-id="' + escapeHtml(String(p.id || '')) + '" data-product-variant="' + escapeHtml(String(p.variant || '')) + '">' +
        '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M12 20.7l-1.45-1.32C5.4 14.74 2 11.66 2 7.92 2 5.1 4.2 3 6.9 3c1.54 0 3.04.73 4.1 1.88C12.06 3.73 13.56 3 15.1 3 17.8 3 20 5.1 20 7.92c0 3.74-3.4 6.82-8.55 11.46L12 20.7z" stroke="currentColor" stroke-width="1.4" fill="none"/></svg>' +
      '</button>' +
    '</li>';
  }

  /* ============================================================
     同意ゲート — モーダル内「上記事項に同意する」でカートボタン活性化
     ============================================================ */
  if (typeof customElements !== 'undefined' && !customElements.get('pbk-consent-gate')) {
    customElements.define('pbk-consent-gate', class extends HTMLElement {
      connectedCallback() {
        this.addBtn = this.querySelector('[data-pbk-add]');
        this.modalSelector = this.getAttribute('data-modal');
        this.agreed = false;
        this.attachModal();
        this.attachAddGuard();
        this.syncButtons();
      }
      /* 未同意のままカートボタンを押した時も、チェック行を押した時と同じ注意事項モーダルを開く。
         ネイティブ disabled では click が発火しないため、無効表現は aria-disabled に寄せて
         ここで submit を止めている（販売期間外・在庫切れは disabled のままなので到達しない）。 */
      attachAddGuard() {
        if (this._addGuardBound || !this.addBtn) return;
        var self = this;
        this.addBtn.addEventListener('click', function (e) {
          if (self.agreed || self.addBtn.hasAttribute('data-pbk-unavailable')) return;
          e.preventDefault();
          e.stopPropagation();
          self.openNoticeModal();
        });
        this._addGuardBound = true;
      }
      openNoticeModal() {
        var opener = this.querySelector('.pbk-consent__row');
        if (opener) {
          opener.click();
          return;
        }
        var modal = this.modalSelector ? document.querySelector(this.modalSelector) : null;
        if (modal && typeof modal.show === 'function') modal.show(this.addBtn);
      }
      /* モーダル内 同意ボタンへのバインド（冪等）。
         注入(quick-view)時は既定義 custom element が同期 upgrade され、その時点で
         後方の notice モーダルが未生成 → connectedCallback では掴めない。
         → PBKProductLoose.init(root) から再度呼び、body へ移動済みのモーダルを掴む。 */
      attachModal() {
        if (this._agreeBound) return;
        var modal = this.modalSelector ? document.querySelector(this.modalSelector) : null;
        if (!modal) return;
        var agreeBtn = modal.querySelector('[data-pbk-consent-agree]');
        if (!agreeBtn) return;
        var self = this;
        agreeBtn.addEventListener('click', function () { self.onAgree(); });
        this._agreeBound = true;
      }
      onAgree() {
        this.agreed = true;
        this.classList.add('is-read');
        var checkmark = this.querySelector('[data-pbk-consent-checkmark]');
        if (checkmark) checkmark.classList.add('is-checked');
        var modal = this.modalSelector ? document.querySelector(this.modalSelector) : null;
        if (modal && typeof modal.hide === 'function') modal.hide();
        this.syncButtons();
      }
      syncButtons() {
        var btn = this.addBtn;
        if (!btn) return;
        var unavailable = btn.hasAttribute('data-pbk-unavailable');
        var ok = this.agreed && !unavailable;
        /* 本当に買えない時だけネイティブ disabled。未同意はクリックを受けてモーダルを開く */
        btn.disabled = unavailable;
        btn.setAttribute('aria-disabled', String(!ok));
      }
    });
  }

  /* ============================================================
     画像拡大モーダル — カルーセル + 手のひら実寸スライド
     ============================================================ */
  function ensureZoom(modal) {
    if (modal._pbkZoom) return modal._pbkZoom;
    var stage = modal.querySelector('[data-pbk-zoom-stage]');
    if (!stage) return null;
    /* scrim（スライド外の余白）クリックで閉じる（media-modal を外したため自前実装） */
    var dialog = modal.querySelector('.pbk-pdp-zoom__dialog');
    if (dialog) {
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog && typeof modal.hide === 'function') modal.hide();
      });
    }
    var realSlides = Array.prototype.slice.call(stage.querySelectorAll('[data-zoom-slide]'));
    if (!realSlides.length) return null;
    var prev = modal.querySelector('[data-pbk-zoom-prev]');
    var next = modal.querySelector('[data-pbk-zoom-next]');
    var n = realSlides.length;
    /* 無限ループ（Figma コメント 1853567102: 前後に空きを入れない・末尾→先頭連続）。
       先頭/末尾の複製を track 両端に足し、端に来たら transition 後に無音スナップで実スライドへ戻す。
       これで両端に常に前後スライドが見切れ、境界の空白と巻き戻しジャンプが消える。 */
    var loop = n > 1;
    if (loop) {
      var cloneFirst = realSlides[0].cloneNode(true);
      var cloneLast = realSlides[n - 1].cloneNode(true);
      [cloneFirst, cloneLast].forEach(function (c) {
        c.setAttribute('data-clone', '1');
        c.removeAttribute('data-index');
        c.classList.remove('is-active');
      });
      stage.insertBefore(cloneLast, realSlides[0]);
      stage.appendChild(cloneFirst);
    }
    var cur = 0;               /* 実スライド index (0..n-1) */
    var trackPos = loop ? 1 : 0; /* track 上の位置（loop 時は先頭複製ぶん +1） */
    var wrapping = false;
    var WRAP_MS = 370;         /* CSS transition 0.35s + マージン */
    var progressThumb = modal.querySelector('[data-pbk-zoom-progress] .pbk-pdp-zoom__progress-thumb');

    /* PC 用 枚数ドット（CL #138②）。実スライド数ぶん生成し paint() でカレントを塗る。
       SP は既存のプログレスバーを使うため CSS 側で display:none。1枚だけならドットは出さない */
    var dots = [];
    if (dialog && n > 1) {
      var dotsEl = dialog.querySelector('[data-pbk-zoom-dots]');
      if (!dotsEl) {
        dotsEl = document.createElement('div');
        dotsEl.className = 'pbk-pdp-zoom__dots';
        dotsEl.setAttribute('data-pbk-zoom-dots', '');
        dotsEl.setAttribute('aria-hidden', 'true');
        dialog.appendChild(dotsEl);
      }
      dotsEl.innerHTML = '';
      for (var d = 0; d < n; d++) {
        var dot = document.createElement('span');
        dot.className = 'pbk-pdp-zoom__dot';
        dotsEl.appendChild(dot);
        dots.push(dot);
      }
    }

    function keyIndex(key) {
      for (var i = 0; i < n; i++) {
        if (realSlides[i].getAttribute('data-index') === String(key)) return i;
      }
      var m = parseInt(key, 10);
      if (isNaN(m)) return 0;
      return Math.max(0, Math.min(n - 1, m));
    }
    function setVar(pos) { stage.style.setProperty('--pbk-zoom-i', pos); }
    function snap(pos) {
      /* transition を切ってスナップ → reflow → 復帰（無音で位置だけ移動） */
      stage.style.transition = 'none';
      setVar(pos);
      void stage.offsetWidth;
      stage.style.transition = '';
      trackPos = pos;
    }
    function paint() {
      realSlides.forEach(function (s, i) { s.classList.toggle('is-active', i === cur); });
      if (progressThumb) {
        progressThumb.style.width = (100 / n) + '%';
        progressThumb.style.transform = 'translateX(' + (cur * 100) + '%)';
      }
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === cur); });
    }
    function go(i) {
      if (wrapping) return;
      if (!loop) { cur = ((i % n) + n) % n; trackPos = cur; setVar(cur); paint(); return; }
      if (i < 0) {                 /* 先頭より前 → 末尾へループ（左の複製へ動かしてから末尾へスナップ） */
        wrapping = true; trackPos = 0; setVar(0); cur = n - 1; paint();
        setTimeout(function () { snap(n); wrapping = false; }, WRAP_MS);
      } else if (i >= n) {         /* 末尾より後 → 先頭へループ（右の複製へ動かしてから先頭へスナップ） */
        wrapping = true; trackPos = n + 1; setVar(n + 1); cur = 0; paint();
        setTimeout(function () { snap(1); wrapping = false; }, WRAP_MS);
      } else {                     /* 通常移動 */
        cur = i; trackPos = loop ? i + 1 : i; setVar(trackPos); paint();
      }
    }
    function open(key, opener) {
      cur = keyIndex(key);
      snap(loop ? cur + 1 : cur); /* 開いた時はアニメ無しで目的スライドへ */
      paint();
      if (typeof modal.show === 'function') modal.show(opener || undefined);
    }
    /* 初期位置（loop 時は実先頭 = track 1 を無音セット。CSS 既定 0 は複製先頭のため要スナップ） */
    snap(trackPos);
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });
    var sx = null;
    stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) go(dx < 0 ? cur + 1 : cur - 1);
      sx = null;
    });
    modal.addEventListener('keyup', function (e) {
      if (!modal.hasAttribute('open')) return;
      if (e.key === 'ArrowLeft') go(cur - 1);
      if (e.key === 'ArrowRight') go(cur + 1);
    });

    /* PC ドラッグで前後スライド切替（Figma コメント）。しきい値 60px。
       ドラッグ中は transition off + --pbk-zoom-i を小数で更新して指に追従、
       離した時に整数 index へ transition スナップ（既存 loop clone 実装と整合）。
       SP は既存 touchstart/touchend スワイプに委譲（pointerType mouse のみ処理）。 */
    var drag = null;
    stage.addEventListener('dragstart', function (e) { e.preventDefault(); });
    stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || wrapping) return;
      /* 動画の再生ボタン / video 本体の上ではドラッグを開始しない。
         下の preventDefault + setPointerCapture は stage 配下の click を全て潰すため、
         そのままだと拡大モーダルで再生ボタンを押しても動画が始まらない（Issue #231）。 */
      if (e.target.closest && e.target.closest('.pbk-pdp-zoom__videobtn, .pbk-pdp-video, video')) return;
      e.preventDefault();
      var step = stage.offsetWidth + 4; /* 1 スライド = 幅100% + gap4px */
      if (!step) return;
      drag = { x: e.clientX, start: trackPos, step: step };
      stage.style.transition = 'none';
      try { stage.setPointerCapture(e.pointerId); } catch (err) {}
    });
    stage.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      setVar(drag.start - dx / drag.step); /* 右ドラッグ→前スライドが覗く */
    });
    function endDrag(e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      drag = null;
      stage.style.transition = ''; /* 整数 index へ transition スナップ */
      if (dx <= -60) go(cur + 1);
      else if (dx >= 60) go(cur - 1);
      else go(cur); /* しきい値未満はスナップバック */
    }
    stage.addEventListener('pointerup', endDrag);
    stage.addEventListener('pointercancel', endDrag);

    modal._pbkZoom = { open: open, go: go };
    return modal._pbkZoom;
  }

  function initZoom(root) {
    var openers = root.querySelectorAll('[data-pbk-zoom-open]');
    if (!openers.length) return;
    var modal = root.querySelector('[data-pbk-zoom]') || document.querySelector('[data-pbk-zoom]');
    if (!modal) return;
    var z = ensureZoom(modal);
    if (!z) return;
    Array.prototype.forEach.call(openers, function (op) {
      if (op.dataset.zoomBound) return;
      op.dataset.zoomBound = '1';
      op.addEventListener('click', function () { z.open(op.getAttribute('data-index'), op); });
      op.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); z.open(op.getAttribute('data-index'), op); }
      });
    });
  }

  /* ============================================================
     SP ギャラリー横スライダー — スクロール比率をプログレスバーへ反映
     ============================================================ */
  function initGallery(root) {
    root.querySelectorAll('[data-pbk-gallery-main]').forEach(function (main) {
      if (main.dataset.galBound) return;
      main.dataset.galBound = '1';
      var gallery = main.closest('[data-pbk-gallery]') || root;
      var progress = gallery.querySelector('[data-pbk-gallery-progress]');
      if (!progress) return;
      var thumb = progress.querySelector('.pbk-pdp-gallery__progress-thumb');
      function update() {
        var sw = main.scrollWidth;
        var cw = main.clientWidth;
        if (!sw || sw <= cw) { thumb.style.width = '100%'; thumb.style.transform = 'none'; return; }
        var w = cw / sw;
        thumb.style.width = (w * 100) + '%';
        var x = main.scrollLeft / (sw - cw);
        thumb.style.transform = 'translateX(' + (x * (1 - w) / w * 100) + '%)';
      }
      main.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ============================================================
     画像拡大アイコン（🔍）を PC でカーソル追従（マウスストーカー）
     Figma コメント 1853390267 / CL #226。
     対象 = メイン画像 + サムネグリッドの各画像タイル（動画タイル/動画メインは除外）。
     ・サイズは CSS の .pbk-pdp-gallery__zoom--follow = Figma 3215:99773 実寸 52px。
       グラフィックも 52px 版 SVG（data-zoom-glyph="pc"）へ CSS で切り替わるので
       線は sw1 のまま（28px SVG を拡大していた旧実装が #226「デザインと違う」の原因）。
     ・位置は CL 指示「カーソルの少し左上」= バッジ中心をカーソルから左上へ
       バッジ半径の半分（52px なら 13px）ずらす。ネイティブカーソル（#228 で指に統一）を
       消さずに虫眼鏡と重ならせないためのオフセット。
     ・追従は lerp イージング（rAF: current += (target-current)*0.3。reduced-motion は即時）。
     ・PC（min-width:990）のみ。SP は CSS で右下固定表示 28px（follow 無効）。
     ・既定は非表示（--follow の opacity:0）→ hover 中のみ表示。
     ============================================================ */
  function initZoomFollow(root) {
    if (!window.matchMedia) return;
    var mq = window.matchMedia('(min-width: 990px)');
    var reduceMq = window.matchMedia('(prefers-reduced-motion: reduce)');
    root.querySelectorAll('[data-pbk-gallery]').forEach(function (gallery) {
      if (gallery.dataset.zoomFollowBound) return;

      function bindFollow(target, badge) {
        /* 中心オフセットはバッジの実寸から毎回求める（CSS 側でサイズを変えても中心が狂わない）。
           28px 固定の HALF=14 をハードコードしていたため、サイズ変更時に右下へズレていた（CL #153②） */
        function half() { return (badge.offsetWidth || 52) / 2; }
        var tx = 0, ty = 0, cx = 0, cy = 0, raf = null, hovering = false;
        function frame() {
          /* lerp 係数（reduced-motion は即時）。0.15 は遅れが大きく「右下にズレて見える」原因になるため 0.3 */
          var f = reduceMq.matches ? 1 : 0.3;
          cx += (tx - cx) * f;
          cy += (ty - cy) * f;
          badge.style.transform = 'translate(' + cx + 'px,' + cy + 'px)';
          if (hovering || Math.abs(tx - cx) > 0.5 || Math.abs(ty - cy) > 0.5) {
            raf = requestAnimationFrame(frame);
          } else {
            raf = null;
          }
        }
        function aim(e) {
          var rect = target.getBoundingClientRect();
          /* ≥1441px は .pbk-pdp に zoom が掛かる（pbk-product-loose.css）。
             clientX/rect は画面 px・transform と offsetWidth はレイアウト px なので、
             差分を zoom で割ってから使う。これを掛け違えていたため、ギャラリー左上から
             離れるほどバッジが右下へズレていた（CL #153②） */
          var z = target.offsetWidth ? rect.width / target.offsetWidth : 1;
          if (!z || !isFinite(z)) z = 1;
          var h = half();
          /* -h でカーソル中心、さらに -h/2 で「カーソルの少し左上」（CL 指示）。
             バッジ中心 = カーソル + (-h/2, -h/2)。52px なら 13px ずつ左上 */
          tx = (e.clientX - rect.left) / z - h - h / 2;
          ty = (e.clientY - rect.top) / z - h - h / 2;
        }
        target.addEventListener('mouseenter', function (e) {
          hovering = true;
          badge.classList.add('is-visible');
          aim(e);
          cx = tx; cy = ty; /* 出現位置＝カーソル（飛び込みなし。以降の移動だけ eased） */
          if (!raf) raf = requestAnimationFrame(frame);
        });
        target.addEventListener('mousemove', function (e) {
          aim(e);
          if (!raf) raf = requestAnimationFrame(frame);
        });
        target.addEventListener('mouseleave', function () {
          hovering = false;
          badge.classList.remove('is-visible');
        });
      }

      function enable() {
        if (gallery.dataset.zoomFollowBound) return;
        gallery.dataset.zoomFollowBound = '1';
        /* follow バッジのソース = メインの既存 zoom バッジ（Figma SVG 2 本を内包・転写済み） */
        var srcBadge = gallery.querySelector('.pbk-pdp-gallery__zoom');
        var targets = [];
        var main = gallery.querySelector('[data-pbk-gallery-main]');
        /* サムネグリッドの各タイルにバッジを複製注入（動画タイルは除外）。
           複製は --follow を付ける前の srcBadge から取る */
        if (srcBadge) {
          gallery.querySelectorAll('.pbk-pdp-gallery__tile').forEach(function (tile) {
            if (tile.querySelector('.pbk-pdp-gallery__tile-play')) return;
            var badge = srcBadge.cloneNode(true);
            tile.appendChild(badge);
            targets.push({ el: tile, badge: badge });
          });
        }
        if (main && !main.classList.contains('pbk-pdp-gallery__main--video-first') && srcBadge) {
          targets.push({ el: main, badge: srcBadge });
        }
        targets.forEach(function (t) {
          t.badge.classList.add('pbk-pdp-gallery__zoom--follow'); /* 追従モード = 既定 opacity:0・52px */
          bindFollow(t.el, t.badge);
        });
        /* CL #228「マウスポインタは指」→ 旧実装の cursor:none（.is-follow-target）は付けない。
           追従位置を左上にずらすことで指カーソルと虫眼鏡の重なりを避ける */
      }
      function onChange() { if (mq.matches) enable(); }
      if (mq.matches) enable();
      if (mq.addEventListener) mq.addEventListener('change', onChange);
      else if (mq.addListener) mq.addListener(onChange);
    });
  }

  /* ============================================================
     Info / Spec タブ
     ============================================================ */
  function initSpecTabs(root) {
    root.querySelectorAll('[data-pbk-spec]').forEach(function (spec) {
      if (spec.dataset.tabsBound) return;
      spec.dataset.tabsBound = '1';
      var tabs = Array.prototype.slice.call(spec.querySelectorAll('[data-pbk-spec-tab]'));
      var panels = Array.prototype.slice.call(spec.querySelectorAll('[data-pbk-spec-panel]'));
      if (!tabs.length) return;

      /* カレントバー: タブ列に1本だけ置き、アクティブタブの実測位置へスライド。
         要素は JS 生成（Liquid 非依存＝ジュエリー版の spec table にもそのまま適用） */
      var list = tabs[0].parentNode;
      var bar = list.querySelector('.pbk-pdp-spec__bar');
      if (!bar) {
        bar = document.createElement('span');
        bar.className = 'pbk-pdp-spec__bar';
        bar.setAttribute('aria-hidden', 'true');
        list.appendChild(bar);
      }
      function moveBar() {
        var active = null;
        tabs.forEach(function (t) { if (!active && t.classList.contains('is-active')) active = t; });
        if (!active) active = tabs[0];
        bar.style.setProperty('--pbk-spec-bar-x', active.offsetLeft + 'px');
        bar.style.setProperty('--pbk-spec-bar-w', active.offsetWidth + 'px');
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var key = tab.getAttribute('data-pbk-spec-tab');
          tabs.forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', String(on));
          });
          panels.forEach(function (p) { p.hidden = p.getAttribute('data-pbk-spec-panel') !== key; });
          moveBar();
        });
      });

      moveBar();
      /* 初期位置は Web フォント未適用の幅で決まる → 確定後に再測定 */
      if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
        document.fonts.ready.then(moveBar);
      }
      /* 幅変化で再配置（RO は quick-view で取り外された後は発火しない＝リーク無し） */
      if (window.ResizeObserver) {
        new ResizeObserver(moveBar).observe(list);
      } else {
        window.addEventListener('resize', function () { if (document.contains(spec)) moveBar(); });
      }
    });
  }

  /* ============================================================
     Stone's Story / Column 横カルーセル
     ============================================================ */
  function initCarousel(root) {
    root.querySelectorAll('[data-pbk-carousel]').forEach(function (track) {
      if (track.dataset.carBound) return;
      track.dataset.carBound = '1';
      var sec = track.closest('.pbk-pdp-sec') || root;
      var prev = sec.querySelector('[data-pbk-car-prev]');
      var next = sec.querySelector('[data-pbk-car-next]');
      function step() {
        var card = track.querySelector('li');
        if (!card) return track.clientWidth * 0.8;
        var style = window.getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || '4') || 4;
        return card.getBoundingClientRect().width + gap;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }

  /* ============================================================
     Same Color — ルース一覧 island を Section Rendering で取得 → 同色描画
     ============================================================ */
  function initColor(sec) {
    if (sec.dataset.colorBound) return;
    sec.dataset.colorBound = '1';
    var grid = sec.querySelector('[data-pbk-color-grid]');
    if (!grid) return;
    var colors = (sec.getAttribute('data-colors') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var currentId = sec.getAttribute('data-current-id');
    var colUrl = sec.getAttribute('data-collection-url');
    var limit = parseInt(sec.getAttribute('data-limit'), 10) || 4;
    if (!colors.length || !colUrl) return;

    /* island を持つテンプレートを指定する。ルース一覧 = ?view=loose、
       ジュエリー一覧 = 既定テンプレート（templates/collection.json = main-collection-jewelry）
       なので view を付けない。CL #295「ジュエリーを見ているとき … 現状はルースになっていて
       情報の違和感が強い」= 旧実装が常に view=loose を付け、ジュエリー PDP でも
       ルース一覧テンプレートの island（ルース商品の情報）を読んでいたため */
    var view = sec.getAttribute('data-view');
    if (view === null) view = 'loose';
    var url = view ? colUrl + (colUrl.indexOf('?') === -1 ? '?' : '&') + 'view=' + encodeURIComponent(view) : colUrl;
    fetch(url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        /* island JSON を文字列抽出（HTML を DOM 化しない = PLP の要素/CSS を一切持ち込まない） */
        var m = html.match(/<script[^>]*data-pbk-products[^>]*>([\s\S]*?)<\/script>/);
        if (!m) return;
        var data;
        try { data = JSON.parse(m[1]); } catch (e) { return; }
        var products = (data && data.products) || [];
        var matches = products.filter(function (p) {
          if (String(p.id) === String(currentId)) return false;
          var pc = Array.isArray(p.colors) ? p.colors : (p.colors ? [p.colors] : []);
          return colors.some(function (c) { return pc.indexOf(c) !== -1; });
        }).slice(0, limit);
        if (!matches.length) return;
        grid.innerHTML = matches.map(function (p) {
          return looseCardHtml({
            url: p.url, title: p.title, code: p.code, img: p.img, img2: p.img2, handle: p.handle, id: p.id, variant: p.variant,
            price_str: p.price_str, price_varies: p.price_varies, price_min_str: p.price_min_str,
            spec: buildSpec(p),
            nameOnly: true /* Same Color も商品名+番号のみ（Figma コメント 1854823020 / 1854824655） */
          });
        }).join('');
        sec.hidden = false;
        document.dispatchEvent(new CustomEvent('pbk:cards-rendered'));
      })
      .catch(function () {});
  }

  /* ============================================================
     Recently — localStorage 'pbk_recently_viewed' → /products/H.js
     ============================================================ */
  function initRecently(sec) {
    if (sec.dataset.recBound) return;
    sec.dataset.recBound = '1';
    var grid = sec.querySelector('[data-pbk-recently-grid]');
    if (!grid) return;
    var limit = parseInt(sec.getAttribute('data-limit'), 10) || 5;
    var current = window.pbkCurrentProductHandle || null;
    var handles = [];
    try {
      var v = JSON.parse(localStorage.getItem('pbk_recently_viewed'));
      if (Array.isArray(v)) handles = v;
    } catch (e) { handles = []; }
    handles = handles.filter(function (h) { return h && h !== current; }).slice(0, limit);
    if (!handles.length) return;

    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (list) {
      var cards = list.filter(Boolean).map(function (prod) {
        return looseCardHtml({
          url: prod.url, title: prod.title,
          code: (prod.variants && prod.variants[0] && prod.variants[0].sku) || '',
          img: prod.featured_image || (prod.images && prod.images[0]) || null,
          img2: (prod.images && prod.images[1]) || null,
          handle: prod.handle, id: prod.id,
          variant: (prod.variants && prod.variants[0] && prod.variants[0].id) || '',
          nameOnly: true /* Recently は商品名+番号のみ（Figma） */
        });
      });
      if (!cards.length) return;
      grid.innerHTML = cards.join('');
      sec.hidden = false;
      document.dispatchEvent(new CustomEvent('pbk:cards-rendered'));
    });
  }

  /* ============================================================
     init（root スコープ）— boot / quick-view 共用
     ============================================================ */
  function init(root) {
    if (!root) return;
    initZoom(root);
    initGallery(root);
    initZoomFollow(root);
    initSpecTabs(root);
    initCarousel(root);
    /* consent-gate は注入時 connectedCallback で modal を掴めない場合があるため再バインド */
    root.querySelectorAll('pbk-consent-gate').forEach(function (g) {
      if (typeof g.attachModal === 'function') { g.attachModal(); }
    });
    root.querySelectorAll('[data-pbk-color-sec]').forEach(initColor);
    root.querySelectorAll('[data-pbk-recently]').forEach(initRecently);
  }

  window.PBKProductLoose = { init: init, looseCardHtml: looseCardHtml };

  /* フルページ PDP: quick-view の pushState 履歴はリロード後に現 document へ紐付き直され、
     戻る操作が popstate になる（URL だけ一覧に変わり画面が PDP のまま）→ 実 URL を再読込 */
  var bootPath = window.location.pathname;
  if (bootPath.indexOf('/products/') !== -1) {
    window.addEventListener('popstate', function () {
      if (window.location.pathname !== bootPath) window.location.reload();
    });
  }

  function boot() {
    document.querySelectorAll('[data-pbk-pdp]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
